import { useMutation } from '@tanstack/vue-query'
import type { LoginResponse } from '~/types/auth'

const useUpdateTimezone = () => {
  const authStore = useAuthStore()

  return useMutation({
    mutationFn: ({ timezone }: { timezone: string }) =>
      $fetch<LoginResponse>(`/api/user/${authStore.user?.id}/timezone`, {
        method: 'POST',
        body: JSON.stringify({
          timezone,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authStore.getToken}`,
        },
      }),
  })
}

export default useUpdateTimezone
